<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content [hidden]="collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Controle Secagem - {{hintNumber}}
                                    ({{hintContrSecEx}}) </mat-label>
                                <input matInput id="txtCtrlSecagem" #txtCtrlSecagem maxlength="80"
                                    formControlName="controle_secagem" name="txtCtrlSecagem" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintControle}}
                                </mat-hint>
                                <mat-hint align="end">{{txtCtrlSecagem.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.controle_secagem)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Secador Câmara ({{hintSecCamEx}})</mat-label>
                                <input matInput id="txtSecCamara" #txtSecCamara maxlength="80"
                                    formControlName="secador_camara">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.secador_camara)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md" *ngIf="isComercial">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Secador Câmara ({{hintSecCamEx}})</mat-label>
                                <mat-select>
                                <input matInput id="txtSecCamara" #txtSecCamara maxlength="80"
                                    formControlName="secador_camara">
                                    <mat-option *ngFor="let item of listSecadorBySite" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.secador_camara)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md col-xs col-sm col-xl text-right">
                            <button mat-flat-button color="primary" class="btnSize" matTooltip="Adicionar"
                                (click)="addItem()">
                                <i class="fa fa-plus fa-1x btnIcon"></i> Adicionar CERAR
                            </button>
                            <button mat-flat-button color="primary" class="btnSize" matTooltip="Remover"
                                (click)="removeItem()" [disabled]="disabledBtnRemove">
                                <i class="fa fa-minus fa-1x btnIcon"></i> Remover
                            </button>
                        </div>
                    </div>

                    <ng-template #viewContainerRef></ng-template>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>